import React from 'react';
import Header from 'layouts/header';
import Footer from 'layouts/footer';
import { Outlet } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/store';
import { asyncFetchUser } from 'store/reducers/user/thunks';
import LoginForm from 'forms/forms/LoginForm';
import ScrollToTop from '../../components/helpers/ScrollToTop';

function MainPage(): React.ReactElement {
    const dispatch = useAppDispatch();

    const getData = React.useCallback(() => {
        dispatch(asyncFetchUser());
    }, [dispatch]);

    React.useEffect(() => {
        if (window.localStorage.getItem('userToken')) getData();
    }, [getData]);

    const { user, sessionLoading } = useAppSelector(state => state.userStore);
    const [open, setOpen] = React.useState(false);

    const onSuccess = React.useCallback(async () => {
        setOpen(false);
        await dispatch(asyncFetchUser()).unwrap();
    }, [dispatch]);

    const username = user
        ? `${user?.first_name} ${user?.last_name}`
        : undefined;

    let content: React.ReactNode = <Outlet />;
    if (sessionLoading)
        content = (
            <div className="rd-container rd-sections" role="status">
                Загружаем профиль…
            </div>
        );

    return (
        <>
            <ScrollToTop />
            <Header
                form={<LoginForm onSuccess={onSuccess} />}
                username={username}
                header={<>Авторизация</>}
                subHeader={<>Откроет доступ к голосованию на выборах</>}
                dispatch={dispatch}
                modalOpen={open}
                setModalOpen={setOpen}
            />
            <main>{content}</main>
            <Footer />
        </>
    );
}

export default React.memo(MainPage);
